import { render } from "./Modal.vue?vue&type=template&id=98704942&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "@siop/standard-libui/dist/css/bootstrap-4/siop.css?vue&type=style&index=0&id=98704942&scoped=true&lang=css&external"
/* custom blocks */
import block0 from "./Modal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98704942"]])

export default __exports__